import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React__default, { forwardRef } from 'react';
import { Flex } from '../Flex/index.js';

/**
 * The Card component is a styled container that serves as the
 * entry point for detailed information.
 *
 * ### Documentation
 * - [Examples](https://blockparty.endpoint.com/components/card#usage)
 * - [Props](https://blockparty.endpoint.com/components/card#props)
 * <br />
 *
 */
const CardSection = /*#__PURE__*/forwardRef((_ref, forwardedRef) => {
  let {
    children,
    ...rest
  } = _ref;
  return /*#__PURE__*/React__default.createElement(Flex, _extends({
    ref: forwardedRef
  }, rest), children);
});

export { CardSection };
